import React, { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { FiUpload, FiX } from 'react-icons/fi';
import './modalsenha.css'; // estilos opcionais

export default function ModalUploadImagem({ isOpen, onClose, onSelecionar, titulo }) {
  const [arquivo, setArquivo] = useState(null);
  const [preview, setPreview] = useState(null);

  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleSelecionar = (e) => {
    const file = e.target.files[0];

    if (file && file.type.startsWith('image/')) {
      setArquivo(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const confirmarImagem = () => {
    if (!arquivo) {
      toast.error("Selecione uma imagem antes de confirmar.");
      return;
    }
    onSelecionar(arquivo);
    onClose();
  };

  const limparImagem = () => {
    setArquivo(null);
    setPreview(null);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-conteudo">
        <h3 className="text-xl font-semibold text-gray-800 text-center">{titulo}</h3>

        <div className="relative flex items-center">
          {/* Botão customizado */}
          <button
            type="button"
            onClick={handleClick}
            className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-green rounded hover:bg-blue-700 transition"
          >
            <label className="text-xl font-semibold text-gray-800 text-center">Selecionar</label>
            <FiUpload color='green' />
          </button>
          {/* Input escondido */}
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleSelecionar}
            className="hidden"
          />
        </div>

        {preview && (
          <div className="relative">
            <img
              src={preview}
              alt="Pré-visualização"
              className="rounded max-h-48 object-contain mx-auto"
            />
            <button
              onClick={limparImagem}
              className="absolute top-2 right-2 bg-white rounded-full p-1 shadow hover:bg-red-100"
            >
              <FiX className="text-red-500 text-lg" />
            </button>
          </div>
        )}

        <div className="flex gap-4 pt-6 mt-6 mb-6 border-t border-secondary justify-center">
          <button  
            className='border border-secondary text-secondary hover:bg-secondary hover:text-white px-10 py-2 rounded-md'
            onClick={confirmarImagem}>Selecionar</button>
          <button           
            className='border border-red-500 text-red-500 hover:bg-red-500 hover:text-white px-10 py-2 rounded-md' 
            onClick={onClose}>Fechar</button>
        </div>

      </div>
    </div>
  );
}